import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { 
  Instagram, 
  Twitter, 
  Facebook, 
  Youtube, 
  Mail, 
  Phone, 
  MapPin,
  ArrowRight,
  MessageSquare
} from "lucide-react";
import rlookEventsLogo from '@/assets/rlook_events.png';

export function PublicFooter() {
  return (
    <footer className="bg-slate-950 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Section 1: Logo and Social Media */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src={rlookEventsLogo} 
                alt="RecruitLook Events Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              From sign-up to final whistle — one platform to run the whole event.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/recruitlook/" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-secondary hover:text-slate-900 transition-all">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://twitter.com/RL_Hoops" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-secondary hover:text-slate-900 transition-all">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/RecruitLook/" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-secondary hover:text-slate-900 transition-all">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/user/RecruitLook" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-secondary hover:text-slate-900 transition-all">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Section 2: More Info */}
          <div>
            <h3 className="text-lg font-black mb-6 text-secondary">MORE INFO</h3>
            <ul className="space-y-4">
              
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-gray-400 hover:text-white transition-colors">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/media-policy" className="text-gray-400 hover:text-white transition-colors">
                  Media Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Terms and Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Section 4: Contact Info */}
          <div>
            <h3 className="text-lg font-black mb-6 text-secondary">CONTACT INFO</h3>
            <div className="space-y-4">
              <div>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Fill out our Contact Form
                </Link>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-secondary" />
                <div>
                  <span className="text-gray-400">Email us: </span>
                  <a href="mailto:info@recruitlook.com" className="text-white hover:text-secondary transition-colors">
                    info@recruitlook.com
                  </a>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <MessageSquare className="w-5 h-5 text-secondary" />
                <div>
                  <span className="text-gray-400">Text Only: </span>
                  <a href="sms:+19133694667" className="text-white hover:text-secondary transition-colors">
                    #913-369-HOOP (4667)
                  </a>
                </div>
              </div>
              <div className="pt-4 border-t border-slate-800">
                <div className="flex flex-col space-y-3">
                  <Link to="/login">
                    <Button variant="outline" className="w-full border-secondary text-secondary hover:bg-secondary hover:text-slate-900 font-black">
                      LOGIN
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm text-gray-400">
              <span>© 2026 RecruitLook. All Rights Reserved.</span>
              <div className="flex items-center space-x-6">
                <Link to="/terms" className="hover:text-white transition-colors">
                  Terms and Conditions
                </Link>
                <Link to="/refund" className="hover:text-white transition-colors">
                  Refund Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}